import Component from "../../component";
import {image} from "tailwindcss/lib/util/dataTypes";

export default class Hero extends Component{

    ready() {

        const images = $(".background-fader picture");
        this.timeout = null;

        $(".background-fader picture img").bind('load', () => {
            this.resize(images);
        });

        if(images.length > 1) {
            this.fader(1, images);
        }

        window.addEventListener('resize', () => {
            this.resize();
        });
    }

    resize(images) {

        const active = $(".background-fader picture.active");
        active.parent('.background-fader').height(active.find('img').height());
    }

    fader(counter, images) {

        if(this.timeout) {
            clearTimeout(this.timeout);
        }
        const current = $(images[counter > 0 ? counter-1 : 0 ]);
        counter++;
        if(counter > images.length) {
            counter = 0;
        }

        const next = $(images[counter]);

        next.prependTo(next.parent('.background-fader')).addClass('active');
        current.removeClass('active');


        this.timeout = setTimeout(() => {
            this.fader(counter, images);
        }, 3000);

    }

}